import { createAction } from '@reduxjs/toolkit';

import { SagaPayload, SagaPayloadwithoutRequestData } from '../api.types';
import {
  CreateSystemUserRequest,
  InitiatePasswordResetRequest,
  ResetPasswordRequest,
  UpdateSystemUserRequest,
  ViewSystemUserRequest
} from './system-user.types';

export const requestCreateSystemUser =
  createAction<SagaPayload<CreateSystemUserRequest, string>['payload']>('request/createSystemUser');

export const requestViewSystemUser =
  createAction<SagaPayload<ViewSystemUserRequest>['payload']>('request/viewSystemUser');

export const requestUpdateSystemUser =
  createAction<SagaPayload<UpdateSystemUserRequest>['payload']>('request/updateSystemUser');

export const requestInitiatePasswordReset = createAction<SagaPayload<InitiatePasswordResetRequest>['payload']>(
  'request/initiatePasswordReset'
);

export const requestResetPassword = createAction<SagaPayload<ResetPasswordRequest>['payload']>('request/resetPassword');

export const requestDeleteAccount = createAction<SagaPayloadwithoutRequestData['payload']>('request/deleteAccount');
